import { render, staticRenderFns } from "./PmaInfo.vue?vue&type=template&id=d5bf7f42&scoped=true"
import script from "./PmaInfo.vue?vue&type=script&lang=js"
export * from "./PmaInfo.vue?vue&type=script&lang=js"
import style0 from "./PmaInfo.vue?vue&type=style&index=0&id=d5bf7f42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bf7f42",
  null
  
)

export default component.exports